export * from "./bsTechpack";
export * from "./bsCareLabel";
